import { MdlDialogReference } from '@angular-mdl/core';
import { Component, HostListener, Inject, InjectionToken } from '@angular/core';
import { DlLink } from '../models/dlLink';
import { ReportDownloader } from '../report-downloader';

export const PREVIEW_TOKEN = new InjectionToken('PreviewItem');

@Component({
    selector: 'preview-dialog',
    template: require('./preview-dialog.component.html'),
    styles: [require('./preview-dialog.component.scss')]
})
export class PreviewDialogComponent {
    public documentHtml: string;
    public documentRootStyles: { [key: string]: string };
    public isDataLoading = true;

    constructor(
        private dialog: MdlDialogReference,
        private reportDownloader: ReportDownloader,
        @Inject(PREVIEW_TOKEN) dlLink: DlLink
    ) {
        this.reportDownloader.getPreview(dlLink).subscribe(html => {
            this.isDataLoading = false;
            const bodyStylesMatch = html.match(/<body[\s\S]*?style[ ]*=\"([\s\S]*?)\"/im);
            const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/im);
            this.documentRootStyles = this.getRootStyles((bodyStylesMatch && bodyStylesMatch[1]) || '');
            this.documentHtml = (bodyMatch && bodyMatch[1]) || html;
        });
    }

    @HostListener('document:keydown.esc')
    public close() {
        this.dialog.hide();
    }

    private getRootStyles(styleString: string): { [key: string]: string } {
        const styleObject = styleString
            .split(';')
            .map(s => s.split(':').map(v => v.trim()))
            .filter(([key, value]) => key && key !== 'white-space')
            .reduce(
                (a: {[key: string]: string}, [key, value]) => {
                    a[key] = value; 
                    return a;
                }, 
                {});
        return styleObject;
    }
}